import axios, { AxiosRequestConfig } from 'axios';
import { LOCAL_STORAGE } from 'constants/general';
import { BASE_URL } from 'constants/routes';
import { getLocalStorage } from 'utils/helpers';
import { v4 as uuidv4 } from 'uuid';

//@TODO it needs handle => timeout: AXIOS_TIMEOUT,
const focusBearApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    accept: '*/*',
    'x-context-id': uuidv4() // Use the correct function name
  },
  signal: new AbortController().signal
});

export const addAccessTokenToInterceptor = () => {
  focusBearApi.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const token = getLocalStorage(LOCAL_STORAGE.BEARER_TOKEN);
      if (token) {
        config!.headers!.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default focusBearApi;
